import { actualizaPaqueteMayorista, deleteImagenTipoPaqueteMayorista, getGaleriaTipoPaqueteMayorista, getPaquetesMayoristaAll, getProveedorTerrestreLista, newImagenTipoPaqueteMayorista, newPaqueteMayorista } from "../services/packageService"

//TODO: Este documento pertenece al nuevo flujo de paquetes mayoristas
const dataInicial = {
    arrayPaquetesMayorista: [],
    total: 0,
    pagina: 0,
    registros: 10,
    busqueda: "NA",
    exito: 0,
    listaTerrestres: [],
    galeria: []

}
const OBTENER_PAQUETE_MAYORISTA_ALL_ACTION = "OBTENER_PAQUETE_MAYORISTA_ALL"
const OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION = "OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION"
const OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION = "OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION"
const OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION = "OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION"
const NUEVO_PAQUETE_MAYORISTA_ACTION = "NUEVO_PAQUETE_MAYORISTA_ACTION"
const ACTUALIZA_PAQUETE_MAYOTISTA_ACTION = "ACTUALIZA_PAQUETE_MAYOTISTA_ACTION"
const NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN = "NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN"
const DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN = "DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN"
const OBTENER_PAQUETE_MAYORISTA_GALERIA = "OBTENER_PAQUETE_MAYORISTA_GALERIA"
//* Paquete terrestre
const OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION = "OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION"
export default function proveedorMayoristaReducer(state = dataInicial, action) {
    if (action.type === OBTENER_PAQUETE_MAYORISTA_ALL_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, pagina: action.payload.pagina }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, registros: action.payload.registros }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
    if (action.type === NUEVO_PAQUETE_MAYORISTA_ACTION)
        return { ...state, exito: action.payload.exito }
    if (action.type === ACTUALIZA_PAQUETE_MAYOTISTA_ACTION)
        return { ...state, exito: action.payload.exito }
    //* Metodos adcionales al mayorista
    if (action.type === NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN)
        return { ...state, exito: action.payload.exito }
    if (action.type === DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN)
        return { ...state, exito: action.payload.exito }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_GALERIA)
        return { ...state, galeria: action.payload.galeria }
    //* paquete terrestre
    if (action.type === OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION)
        return { ...state, listaTerrestres: action.payload.listaTerrestres }
    return { ...state }
}
export const obtenerPaqueteMayoristaAllAction = () => async (dispatch, getState) => {
    const { pagina, registros, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_ALL_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaPaginaAction = (pagina) => async (dispatch, getState) => {
    const { registros, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                pagina: pagina
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaRegistrosAction = (registros) => async (dispatch, getState) => {
    const { pagina, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                registros: registros
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaBusquedaProveedorAction = ({ busqueda }) => async (dispatch, getState) => {
    const { pagina, registros } = dataInicial
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                registros: registros,
                pagina: pagina,
                busqueda: busqueda
            }
        })
        return Response
    })
}
export const crearPaqueteMayoritaAction = ({ IdProveedorGrupoPaquete, ClavePaquete, IdMoneda, IdPaqueteProveedorTerrestre, Nombre, PrecioPublico, TipoCambioPrevisto }) => async (dispatch) => {
    return await newPaqueteMayorista({ IdProveedorGrupoPaquete, ClavePaquete, IdMoneda, IdPaqueteProveedorTerrestre, Nombre, PrecioPublico, TipoCambioPrevisto }).then(Response => {
        dispatch({
            type: NUEVO_PAQUETE_MAYORISTA_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actualizaPaqueteMayoristaAction = ({ IdProveedorGrupoPaquete, ClavePaquete, Estatus, IdMoneda, IdPaqueteMayorista, IdPaqueteProveedorTerrestre, Nombre, PrecioPublico, TipoCambioPrevisto }) => async (dispatch) => {
    return await actualizaPaqueteMayorista({ IdProveedorGrupoPaquete, ClavePaquete, Estatus, IdMoneda, IdPaqueteMayorista, IdPaqueteProveedorTerrestre, Nombre, PrecioPublico, TipoCambioPrevisto }).then(Response => {
        dispatch({
            type: ACTUALIZA_PAQUETE_MAYOTISTA_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPaqueteTerresteAction = () => async (dispatch) => {
    return await getProveedorTerrestreLista().then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION,
            payload: {
                listaTerrestres: Response,
            }
        })
        return Response
    })
}

//* Metodos adicionales al mayorista
export const nuevaImagenTipoPaqueteMayorista = ({ extencion, idPaquete, tipoImagen, imagen }) => async (dispatch) => {
    return await newImagenTipoPaqueteMayorista({ ExtensionImagen: extencion, IdPaqueteMayorista: idPaquete, IdTipoImagen: tipoImagen, ImagenBase64: imagen }).then(Response => {
        dispatch({
            type: NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const elimarImagenTipoPaqueteMayorista = ({ idPaqueteMayoristaImagen }) => async (dispatch) => {
    return await deleteImagenTipoPaqueteMayorista({ IdPaqueteMayoristaImagen: idPaqueteMayoristaImagen }).then(Response => {
        dispatch({
            type: DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN,
            payload: {
                exito: 1
            }
        })
    }).catch(error => {
        return error
    })
}

export const obtenerGaleriaPaqueteMayoritaAction = ({ clavePaquete, tipo }) => async (dispatch) => {
    return await getGaleriaTipoPaqueteMayorista({ clavePaquete, tipo }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_GALERIA,
            payload: {
                galeria: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}